/* eslint-disable max-lines */
/* eslint-disable no-param-reassign */
import { create } from "zustand"
import { devtools } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"

import { calcPrice } from "@components/CurrencyConverter/CurrConvertPrice"
import { useGlobalStore } from "@stores/globalStore"
import {
  bedroomOptions,
  maxAreaSizeOptions,
  maxBedroomOptions,
  maxPriceOptionsResiRent,
  maxPriceOptionsResiSale,
  minAreaSizeOptions,
  minBedroomOptions,
  minPriceOptionsResiRent,
  minPriceOptionsResiSale,
  offplanStatusOptions,
  sortOptions,
  currencyTypeOptions,
  currencyTypeOptionsSymbols,
} from "../SearchFilters/filterOptions"
import { navigate } from "gatsby"
import { isMobile, isTablet } from "react-device-detect"
const isBrowser = typeof window !== "undefined";
const initialState = {
  initialised: false,
  pType: "",
  pDepartment: "",
  pStatus: "",
  offplanStatus: undefined,
  developer: undefined,
  city: undefined,
  cityOptions: [],
  developerOptions: [],
  locationName: "",
  searchState: {},
  searchResult: {},
  filterQuery: "",
  furnished: "",
  minPrice: undefined,
  minPriceOptions: [],
  maxPrice: undefined,
  maxPriceOptions: [],
  bedroom: undefined,
  minBedroom: undefined,
  maxBedroom: undefined,
  minBedroomOptions,
  maxBedroomOptions,
  bedroomOptions,
  minAreaSize: undefined,
  maxAreaSize: undefined,
  minAreaSizeOptions,
  maxAreaSizeOptions,
  buildingType: { label: "Property Type", value: "" },
  buildingTypeOptions: [],
  searchText: "",
  crmId: "",
  searchSlug: "",
  areaJSON: [],
  offplanJSON: [],
  includeSold: false,
  showMap: false,
  sortBy: undefined,
  sortByOptions: sortOptions,
  offplanStatusOptions,
  selectedAreas: [],
  selectedAmenities: [],
  listView : isTablet || isMobile
    ? false
    : true,
offlistView: false,
  currencyType: { value: "AED", label: "AED" },
  currencyTypeOptions: [],
  statusType: '',
}
export const usePropertyStore = create(
  devtools(
    immer((set, get) => ({
      ...initialState,
      setListView: (listView) =>
        set((state) => {
          state.listView = listView
        }),
        setOffListView: (offlistView) =>
          set((state) => {
            state.offlistView = offlistView
          }),
      setPType: (pType) =>
        set((state) => {
          state.pType = pType
        }),
      setStatusType: (statusType) =>
        set((state) => {
          state.statusType = statusType
        }),
      setPDepartment: (pDepartment) =>
        set((state) => {
          state.pDepartment = pDepartment
        }),
      setPStatus: (pStatus) =>
        set((state) => {
          state.pStatus = pStatus
        }),
      setOffplanStatus: (offplanStatus) =>
        set((state) => {
          state.offplanStatus = offplanStatus
        }),
      setDeveloper: (developer) =>
        set((state) => {
          state.developer = developer
        }),
      setDeveloperOptions: (developerOptions) =>
        set((state) => {
          state.developerOptions = developerOptions
        }),
        setCity: (city) =>
          set((state) => {
            state.city = city
          }),
        setCityOptions: (cityOptions) =>
          set((state) => {
            state.cityOptions = cityOptions
          }),
      setLocationName: (locationName) =>
        set((state) => {
          state.locationName = locationName
        }),
      setSearchState: (searchState) =>
        set((state) => {
          state.searchState = searchState
        }),
      setSearchResult: (searchResult) =>
        set((state) => {
          state.initialised = true
          state.searchResult = searchResult
        }),
      setFilterQuery: (filterQuery) =>
        set((state) => {
          state.filterQuery = filterQuery
        }),
      setFurnished: (furnished) =>
        set((state) => {
          state.furnished = furnished
        }),
      setMinPrice: (minPrice) =>
        set((state) => {
          const { currencyType } = useGlobalStore.getState()
          const convertedMinPrice = {
            label:
              minPrice?.value === ""
                ? minPrice?.label
                : `${currencyType?.value} ${parseInt(
                    calcPrice(minPrice?.value, currencyType?.value, "AED"),
                    10
                  ).toLocaleString("en-US")}`,
            value: minPrice?.value,
          }
          const maxPriceOptions =
            get()?.pType === "sales"
              ? maxPriceOptionsResiSale
              : maxPriceOptionsResiRent

          state.minPrice = convertedMinPrice
          state.maxPriceOptions = maxPriceOptions.filter(
            (priceOption) =>
              !priceOption?.value ||
              !minPrice?.value ||
              Number(priceOption?.value) > Number(minPrice?.value)
          )
        }),
      setMaxPrice: (maxPrice) =>
        set((state) => {
          const { currencyType } = useGlobalStore.getState()
          const convertedMaxPrice = {
            label:
              maxPrice?.value === ""
                ? maxPrice?.label
                : `${currencyType?.value} ${parseInt(
                    calcPrice(maxPrice?.value, currencyType?.value, "AED"),
                    10
                  ).toLocaleString("en-US")}`,
            value: maxPrice?.value,
          }
          const minPriceOptions =
            get()?.pType === "sales"
              ? minPriceOptionsResiSale
              : minPriceOptionsResiRent

          state.maxPrice = convertedMaxPrice
          state.minPriceOptions = minPriceOptions.filter(
            (priceOption) =>
              !priceOption?.value ||
              !maxPrice?.value ||
              Number(priceOption?.value) < Number(maxPrice?.value)
          )
        }),
      setMinPriceOptions: (minPriceOptions) =>
        set((state) => {
          state.minPriceOptions = minPriceOptions
        }),
      setMaxPriceOptions: (maxPriceOptions) =>
        set((state) => {
          state.maxPriceOptions = maxPriceOptions
        }),
      setBedroom: (bedroom) =>
        set((state) => {
          state.bedroom = bedroom
        }),
      setBedroomOptions: (bedroomOptionsProp) =>
        set((state) => {
          state.bedroomOptions = bedroomOptionsProp
        }),
      setMinBedroom: (minBedroom) =>
        set((state) => {
          state.minBedroom = minBedroom
          state.maxBedroomOptions = maxBedroomOptions.filter(
            (bedroomOption) =>
              !bedroomOption.value ||
              !minBedroom.value ||
              Number(bedroomOption.value) >= Number(minBedroom.value)
          )
        }),
      setMaxBedroom: (maxBedroom) =>
        set((state) => {
          state.maxBedroom = maxBedroom
          state.minBedroomOptions = minBedroomOptions.filter(
            (bedroomOption) =>
              !bedroomOption.value ||
              !maxBedroom.value ||
              Number(bedroomOption.value) <= Number(maxBedroom.value)
          )
        }),
      setMinAreaSize: (minAreaSize) =>
        set((state) => {
          state.minAreaSize = minAreaSize
          // state.maxAreaSizeOptions = maxAreaSizeOptions.filter(
          //   (areaOption) =>
          //     !areaOption.value ||
          //     !minAreaSize.value ||
          //     Number(areaOption.value) > Number(minAreaSize.value)
          // )
        }),
      setMinAreaSizeOptions: (minAreaSizeOptionsProp) =>
        set((state) => {
          state.minAreaSizeOptions = minAreaSizeOptionsProp
        }),
      setMaxAreaSize: (maxAreaSize) =>
        set((state) => {
          state.maxAreaSize = maxAreaSize
          // state.minAreaSizeOptions = minAreaSizeOptions.filter(
          //   (areaOption) =>
          //     !areaOption.value ||
          //     !maxAreaSize.value ||
          //     Number(areaOption.value) < Number(maxAreaSize.value)
          // )
        }),
      setMaxAreaSizeOptions: (maxAreaSizeOptionsProp) =>
        set((state) => {
          state.maxAreaSizeOptions = maxAreaSizeOptionsProp
        }),
      setBuildingType: (buildingType) =>
        set((state) => {
          state.buildingType = buildingType
        }),
      setBuildingTypeOptions: (buildingTypeOptions) =>
        set((state) => {
          state.buildingTypeOptions = buildingTypeOptions
        }),
      setSearchText: (searchText) =>
        set((state) => {
          state.searchText = searchText || ""
        }),
        setcrmId: (crmId) =>
        set((state) => {
          state.crmId = crmId || ""
        }),
        
      setSearchSlug: (searchSlug, editSearchText) =>
        set((state) => {
          const isoffplan = get()?.pDepartment === "new_developments"

          if (editSearchText) {
            const areaJSON = isoffplan ? get()?.offplanJSON : get()?.areaJSON

            const area = areaJSON
              ?.filter((item) => item.slug === searchSlug)
              ?.pop()
            state.searchSlug = searchSlug
            state.searchText = area?.name || ""
          } else {
            state.searchSlug = searchSlug
          }
        }),
      setCurrencyType: (currencyType) =>
        set((state) => {
          state.currencyType = currencyType
        }),
      setCurrencyTypeOptions: (currencyOptions) =>
        set((state) => {
          state.currencyTypeOptionsSymbols = currencyOptions
        }),

      setAreaJSON: (areaJSON) =>
        set((state) => {
          state.areaJSON = areaJSON
        }),
      setOffplanJSON: (offplanJSON) =>
        set((state) => {
          state.offplanJSON = offplanJSON
        }),
      setIncludeSold: (includeSold) =>
        set((state) => {
          state.includeSold = !!includeSold
        }),
      setShowMap: (showMap) =>
        set((state) => {
          state.showMap = !!showMap
        }),
      setSortBy: (sortBy) =>
        set((state) => {
          state.sortBy = sortBy
        }),
      setSortByOptions: (sortByOptions) =>
        set((state) => {
          state.sortByOptions = sortByOptions
        }),
      setOffplanStatusOptions: (offplanStatusOptionsProp) =>
        set((state) => {
          state.offplanStatusOptions = offplanStatusOptionsProp
        }),
      setSelectedAmenities: (amenities) => {
        set((state) => {
          state.selectedAmenities = amenities
        })
      },
      addAmenity: (amenity) => {
        set((state) => {
          const amenityExists = state.selectedAmenities.some(
            (selectedAmenity) => selectedAmenity.value === amenity.value
          )
          if (!amenityExists) {
            state.selectedAmenities.push(amenity)
          }
        })
      },
      removeAmenity: (amenity) => {
        set((state) => {
          state.selectedAmenities = state.selectedAmenities.filter(
            (selectedAmenity) => selectedAmenity.value !== amenity.value
          )
        })
      },
      removeAllAmenities: () => {
        set((state) => {
          state.selectedAmenities = []
        })
      },
      setSelectedAreas: (areas) => {
        set((state) => {
          state.selectedAreas = areas
        })
      },
      addSelectedArea: (area) => {
        set((state) => {
          const areaExists = state.selectedAreas.some(
            (selectedArea) => selectedArea.slug === area.slug
          )
          if (!areaExists) {
            state.selectedAreas.push(area)
          }
        })
      },
      removeSelectedArea: (area) => {
        set((state) => {
          state.selectedAreas = state.selectedAreas.filter(
            (selectedArea) => selectedArea.slug !== area.slug
          )
        })
      },
      removeSelectedAreas: (areas) => {
        set((state) => {
          state.selectedAreas = state.selectedAreas.filter(
            (selectedArea) =>
              !areas.some((area) => area.slug === selectedArea.slug)
          )
        })
      },
      removeAllSelectedAreas: () => {
        set((state) => {
          state.selectedAreas = []
        })
      },
      clearFilters: () => {
        // const buildingTypeList = get()?.buildingTypeOptions
        // const bedroomList = get()?.bedroomOptions
        // const minAreaSizeList = get()?.minAreaSizeOptions
        // const maxAreaSizeList = get()?.maxAreaSizeOptions
        // const minPriceList = get()?.minPriceOptions
        // const maxPriceList = get()?.maxPriceOptions
        // const offplanStatusList = get()?.offplanStatusOptions
        // const developerList = get()?.developerOptions
        // const currencyTypeList = get()?.currencyTypeOptionsSymbols
        // const countryOptionsList = get()?.countryOptions

        // set((state) => {
        //   state.buildingType = buildingTypeList?.[0]
        //   state.bedroom = bedroomList?.[0]
        //   state.minBedroom = minBedroomOptions?.[0]
        //   state.maxBedroom = maxBedroomOptions?.[0]
        //   state.minAreaSize = undefined
        //   state.maxAreaSize = undefined
        //   state.minPrice = minPriceList?.[0]
        //   state.maxPrice = maxPriceList?.[0]
        //   state.selectedAmenities = []
        //   state.selectedAreas = []
        //   state.offplanStatus = offplanStatusList?.[0]
        //   state.developer = developerList?.[0]
        //   state.currencyType = currencyTypeList?.[0]
        //   state.country = countryOptionsList?.[0]
        //   state.crmId = ""
        // })
        if (typeof window !== "undefined") {
        const currentPathname = window?.location?.pathname
        
        if (currentPathname?.includes("/new-projects/")) {
          navigate("/new-projects/")
          return
        }
  
        if (
          currentPathname?.includes("-for-sale/") ||
          currentPathname?.includes("-for-rent/")
        ) {
          if (currentPathname?.includes("-for-sale/")){
            navigate("/buy/properties-for-sale/", { replace: true })
            return
          }
          if (currentPathname?.includes("-for-rent/")){
            navigate("/let/properties-for-rent/", { replace: true })
            return
          }
          
        }
      }
      },
      reset: () => {
        set((state) => {
          state.initialised = false
          state.pType = ""
          state.pDepartment = ""
          state.pStatus = ""
          state.locationName = ""
          state.searchState = {}
          state.searchResult = {}
          state.filterQuery = ""
          state.minPrice = undefined
          state.minPriceOptions = []
          state.maxPrice = undefined
          state.maxPriceOptions = []
          state.bedroom = undefined
          state.minBedroom = undefined
          state.maxBedroom = undefined
          state.minBedroomOptions = minBedroomOptions
          state.maxBedroomOptions = maxBedroomOptions
          state.bedroomOptions = bedroomOptions
          state.minAreaSize = undefined
          state.maxAreaSize = undefined
          state.minAreaSizeOptions = minAreaSizeOptions
          state.maxAreaSizeOptions = maxAreaSizeOptions
          state.buildingType = undefined
          state.buildingTypeOptions = []
          state.searchText = ""
          state.crmId = ""
          state.searchSlug = ""
          state.includeSold = false
          state.showMap = false
          state.sortBy = undefined
          state.sortByOptions = sortOptions
          state.selectedAreas = []
          state.selectedAmenities = []
          state.offplanStatus = undefined
          state.offplanStatusOptions = offplanStatusOptions
          state.developer = undefined
          state.developerOptions = []
          state.city = undefined
          state.cityOptions = []
          state.currencyType = undefined
          state.currencyTypeOptions = currencyTypeOptionsSymbols
          state.statusType = ""
        })
      },
    }))
  )
)
